<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.go(-1)"
      />
      <div class="big_tit">
        {{ $t('safe.setting') }}
      </div>
    </div>
    <div class="wrap_box">
      <div class="item">
        <div class="left">
          <img
            src="../images/about/icon11.png"
            alt=""
          >
          <span class="icon icon_id" />
          <span class="info">{{ $t('safe.verified') }}</span>
        </div>
        <div
          v-if="data.is_auth == '1'"
          class="right_info"
        >
          {{ $t('safe.verifiedIdentity') }}
        </div>
        <router-link
          v-if="data.is_auth == '0'"
          to="/authEmail"
          class="right_info auth"
        >
          {{ $t('safe.toVerify') }}<div class="right icon_right" />
        </router-link>
      </div>
      <router-link
        to="/account"
        class="item"
      >
        <div class="left">
          <img
            src="../images/about/icon10.png"
            alt=""
          >
          <span class="icon icon_login" />
          <span class="info">{{ $t('safe.paymentOptions') }}</span>
        </div>
        <div class="right icon_right" />
      </router-link>
      <router-link
        to="/language"
        class="item"
      >
        <div class="left">
          <img
            src="../images/about/icon4.png"
            alt=""
          >
          <span class="icon icon_login" />
          <span class="info">{{ $t('safe.language') }}</span>
        </div>
        <div class="right icon_right" />
      </router-link>
      <router-link
        to="/setpwd"
        class="item"
      >
        <div class="left">
          <img
            src="../images/about/icon5.png"
            alt=""
          >
          <span class="icon icon_login" />
          <span class="info">{{ $t('safe.signInPassword') }}</span>
        </div>
        <div class="right icon_right" />
      </router-link>
      <router-link
        to="/setpaypwd"
        class="item"
      >
        <div class="left">
          <img
            src="../images/about/icon6.png"
            alt=""
          >
          <span class="icon icon_pay" />
          <span class="info">{{ $t('safe.paymentPassword') }}</span>
        </div>
        <div class="right icon_right" />
      </router-link>
      <router-link
        to="/about/20"
        class="item"
      >
        <div class="left">
          <img
            src="../images/about/icon3.png"
            alt=""
          >
          <span class="icon icon_greement" />
          <span class="info">{{ $t('index.agreement') }}</span>
        </div>
        <div class="right icon_right" />
      </router-link>
      <router-link
        to="/about/21"
        class="item"
      >
        <div class="left">
          <img
            src="../images/about/icon0.png"
            alt=""
          >
          <span class="icon icon_policy" />
          <span class="info">{{ $t('index.secret') }}</span>
        </div>
        <div class="right icon_right" />
      </router-link>
    </div>

    <div
      class="history_coupon flex_center basic_btn"
      @click="logout"
    >
      <span>{{ $t('safe.signOut') }}</span>
    </div>
  </div>
</template>

<script>
	import Fetch from '../../utils/fetch'
	import bsHeader from '../../components/bsHeader.vue'
	export default {
		name: "Safe",
		components: {
			bsHeader
		},
		data() {
			return {
				data: {},
				appVer:"",
				wgtVer:"",
			};
		},
		created() {
			this.$parent.footer('user', false);
		},
		mounted() {
			this.start();
			// this.getVersion();
		},
		methods: {
			start() {
				Fetch('/user/info').then((r) => {
					this.data = r.data;
				});
			},
			logout() {
				localStorage.removeItem('token');
				this.$router.replace("/");
			}
		}
	};
</script>

<style lang="less" scoped>
	
	.wrap_box{
		margin: 5px;
		display: flex;
		flex-direction: column;
		align-items: center;
		.item{
			height: 50px;
			width: 95%;
			padding: 16px 0;
			border-bottom: 1px solid #ECECEC;
			font-size: 12px;
			color: rgba(0,0,0,.8);
			font-weight: bold;
			line-height: 20px;
			display: flex;
			justify-content: space-between;
			.left{
				img{
					vertical-align: middle;
					height: 25px;
					width: 25px;
					margin-right: 10px;
				}
			}
			.right{
				width: 20px;
				height: 20px;
				background: url(../images/user/arrow.png) no-repeat center center;
				background-size: 100% 100%;
			}
			.right_info{
				color: rgba(0,0,0,.6);
			}
			.tips{
				color: rgba(0,0,0,.6);
				margin-left: auto;
				margin-right: 4px;
				font-weight: normal;
			}
		}
	}
	.history_coupon{
		margin: 131px auto 0 auto;
		width:356px;
		border-radius:5px;
		border:1px solid rgba(0,0,0,0.3);
		text-align: center;
		span{
			font-size: 14px;
			height: 20px;
			line-height: 20px;
			position: relative;
			&::after{
				content: '';
				position: absolute;
				top: 3px;
				right: -25px;
				width: 12px;
				height: 13px;
				background: url(../images/user/more.png) no-repeat center center;
				background-size: 100% 100%;
			}
		}
	}
	
	.auth{
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}
</style>
